var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84735 0.381057C-0.929929 3.09071 -0.949499 7.16422 2.7915 12.0405C3.84499 13.4138 6.03711 15.5874 7.0756 16.2885C9.68097 18.0474 12.1791 18.4604 14.2968 17.4821C15.2644 17.0352 16.7337 15.7912 16.9477 15.2375C17.1481 14.7189 16.7831 14.0982 15.6685 13.0621C13.8564 11.3776 12.8967 11.142 11.6952 12.0867C11.315 12.3856 10.8847 12.7627 10.739 12.9246C9.86067 13.9014 8.17037 13.0759 6.17753 10.6971C5.01219 9.30608 4.5078 8.33617 4.5058 7.48315C4.50423 6.82977 4.58722 6.71952 5.83055 5.72395C7.09988 4.70751 7.0586 3.82262 5.64314 1.7019C4.45294 -0.0814085 3.87356 -0.355081 2.84735 0.381057Z",
    fill: "#393184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon2);
export default __webpack_public_path__ + "static/media/phone-icon2.84537d4733dfe2ddc2791070cf91b40f.svg";
export { ForwardRef as ReactComponent };